module.exports = __webpack_public_path__ + "images/featured-content-image.svg";